export const endpoints = {
  list: () => '/commons/jobs',
  retrieve: uid => `/commons/jobs/${uid}/`,
};
